import React, { createContext, useCallback } from 'react';

import { useVar } from '@hooks';

type OnChangeQueryListenerType = (query: string) => void;

export interface ISearchTabNavigatorContext {
  setQuery(query: string): void;
  addChangeQueryListener(listener: OnChangeQueryListenerType): void;
}

export const SearchTabNavigatorContext =
  createContext<ISearchTabNavigatorContext>({
    setQuery: () => {},
    addChangeQueryListener: () => {},
  });

interface ISearchTabNavigatorProviderProps {
  children: React.ReactNode;
}

export function SearchTabNavigatorProvider({
  children,
}: ISearchTabNavigatorProviderProps) {
  const onChangeQueryListeners = useVar<OnChangeQueryListenerType[]>(
    [],
  );

  const setQuery = useCallback((query: string) => {
    // Sync query with all screens
    onChangeQueryListeners.forEach((listener) => listener(query));
  }, []);

  const addChangeQueryListener = useCallback(
    (listener: OnChangeQueryListenerType) => {
      onChangeQueryListeners.push(listener);
    },
    [],
  );

  return (
    <SearchTabNavigatorContext.Provider
      value={{ addChangeQueryListener, setQuery }}
    >
      {children}
    </SearchTabNavigatorContext.Provider>
  );
}
